export default __webpack_public_path__ + "static/pay_compare_comp2_inactive-a98cd5b6ed770317edda70d687a3170a.png";